<template>
  <div class="card-wrapper">
    <img class="card-img" src="../../../public/custom/images/cards/card.png" alt="Card image">
    <div class="card-data-container">
      <div class="card-data-title">
        <div class="data-card">{{ $t('message.cardsPage.card.card') }}</div>
        <div class="data-expiry" :class="{'card-expired': data.expired}">{{ $t('message.cardsPage.card.expiry') }}</div>
        <div class="data-check" @click.stop="setDefaultCard()">
          <div v-if="!isDefaultCard" class="not-checked"></div>
          <img v-if="isDefaultCard" class="checked" src="../../../public/custom/images/cards/radiobutton.svg" alt="Card radio button">
        </div>
      </div>
      <div class="card-data">
        <div class="data-card">{{ data.pan | cardPan }}</div>
        <div class="data-expiry">{{ data.expiry | cardExpiry }}</div>
        <div class="data-check"></div>
      </div>
      <div class="underline"></div>
      <div class="actions-block">
        <div class="card-brand">
          <span v-if="isNotVerified">{{ $t('message.cardsPage.notVerified') }}</span>
        </div>
        <div class="delete-card" @click="deleteCard()">{{ $t('message.cardsPage.card.delete') }}</div>
      </div>
    </div>

    <div class="mobile-img-block">
      <img class="mobile-card-img" src="../../../public/custom/images/cards/mobile-card.svg" alt="Card image">
      <div class="data-check" @click.stop="setDefaultCard()">
        <div v-if="!isDefaultCard" class="not-checked"></div>
        <img v-if="isDefaultCard" class="checked" src="../../../public/custom/images/cards/radiobutton.svg" alt="Card radio button">
      </div>
    </div>
    <div class="mobile-card-data-container">
      <div class="mobile-card-title">{{ $t('message.cardsPage.card.card') }}</div>
      <div class="mobile-card-pan">{{ data.pan | cardPan }}</div>
      <div class="mobile-card-expiry-title" :class="{'mobile-card-expired': data.expired}">{{ $t('message.cardsPage.card.expiry') }}</div>
      <div class="mobile-card-expiry">{{ data.expiry | cardExpiry }}</div>
      <div class="mobile-underline"></div>
      <div class="mobile-delete-card" @click="deleteCard()">
        <div class="mobile-not-verified">
          <span v-if="isNotVerified">{{ $t('message.cardsPage.notVerified') }}</span>
        </div>
        <span>{{ $t('message.cardsPage.card.delete') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  inject: ['$httpService'],
  props: {
    data: Object,
    defaultCardId: String
  },
  methods: {
    async setDefaultCard() {
      if (!this.isDefaultCard && !this.isNotVerified) {
        await this.$store.dispatch('setDefaultCard' ,this.data.id);
      }
    },
    deleteCard() {
      this.$emit('deleteCard', this.data.id);
    }
  },
  computed: {
    isDefaultCard() {
      return this.data.id === this.defaultCardId;
    },
    isNotVerified() {
      return this.data.state === 'VERIFICATION_FAILED';
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-wrapper {
    width: 100%;
    max-width: 1400px;
    padding: 36px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    background: #F8F8F8;
    // box-shadow: 2px 2px 30px rgba(177, 179, 182, 0.2);
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .card-wrapper:not(:last-of-type) {
    margin-bottom: 50px;
  }

  .card-wrapper:hover {
    transform: scale(1.005);
  }

  .card-img {
    object-fit: contain;
  }

  .card-data-container {
    width: calc(100% - 357px);
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .card-data-title {
    width: 100%;
    display: flex;
    margin-bottom: 21px;
    font-weight: 600;
    font-size: 22px;
    line-height: 130%;
    color: #333333;
  }

  .card-data {
    width: 100%;
    margin-bottom: 42px;
    display: flex;
    font-weight: 600;
    font-size: 26px;
    line-height: 35px;
    color: #121212;
  }

  .data-card,
  .data-expiry {
    width: 43%;
    margin-right: 3%;
  }

  .data-check {
    width: 8%;
    display: flex;
    justify-content: flex-end;
  }

  .not-checked {
    width: 38px;
    height: 38px;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #CDCDCD;
    border-radius: 50%;
  }

  .checked {
    width: 38px;
    height: 38px;
  }

  .underline,
  .mobile-underline {
    width: 100%;
    height: 2px;
    background: #ECEEF0;
    border-radius: 3px;
  }

  .actions-block {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    font-size: 22px;
    line-height: 130%;
    color: #878787;
  }

  .card-brand {
    margin-top: 15px;
    display: flex;
    color: #EB5757;
  }

  .delete-btn {
    margin-top: 6px;
    cursor: pointer;
  }

  .card-expired {
    color: #EB5757;
  }

  .delete-card,
  .mobile-delete-card {
    margin-top: 24px;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #878787;
    cursor: pointer;

    &:hover {
      color: black;
    }
  }

  .mobile-img-block {
    width: 100%;
    display: none;
    justify-content: space-between;
    height: auto;
    margin-bottom: 20px;

    .mobile-card-img {
      width: 50%;
    }
  }

  .mobile-card-data-container {
    width: 100%;
    display: none;
    flex-direction: column;
  }

  .mobile-card-title {
    margin-bottom: 5px;
    font-weight: 400;
    font-size: 18px;
    line-height: 130%;
    color: #333333;
  }

  .mobile-card-pan {
    margin-bottom: 15px;
    font-weight: 600;
    font-size: 22px;
    line-height: 30px;
    color: #121212;
  }

  .mobile-card-expiry-title {
    margin-bottom: 5px;
    font-weight: 400;
    font-size: 18px;
    line-height: 130%;
    color: #333333;
  }

  .mobile-card-expired {
    color: #EB5757;
  }

  .mobile-card-expiry {
    margin-bottom: 20px;
    font-weight: 600;
    font-size: 22px;
    line-height: 30px;
    color: #121212;
  }

  .mobile-underline {
    margin-bottom: 20px;
  }

  .mobile-delete-card {
    margin-top: 0;
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;

    .mobile-not-verified {
      font-size: 12px;
      color: #EB5757;
    }
  }

  @media screen and (max-width: 965px) {
    .card-wrapper:hover {
      transform: none;
    }
    .card-wrapper {
      padding: 15px;
      flex-direction: column;
    }

    .card-img {
      display: none;
    }

    .card-data-container {
      display: none;
    }

    .mobile-img-block {
      display: flex;
    }

    .data-check {
      width: 34px;
    }

    .not-checked,
    .checked {
      width: 34px;
      height: 34px;
    }

    .mobile-card-data-container {
      display: flex;
    }
  }
</style>